import {getScreenWidth} from './dimensions';

const guidelineBaseWidth = 375;
const TABLET_MIN_WIDTH = 768;

export const isTablet = (): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  return window.innerWidth >= TABLET_MIN_WIDTH;
};

const scaleSize = (size: number): number => {
  const width = getScreenWidth();
  const factor = isTablet() ? 1.25 : 1;
  return (width / guidelineBaseWidth) * size * factor;
};

export default scaleSize;
